<template>
  <div class="distributor-box back-fff p20">
    <!--消息中心列表-->
    <div class="newsList_box">
      <Tabs v-model="tabsName" @on-click="changeTab" :animated="false">
        <TabPane v-for="(ele, ids) in typeList" :label="ele.label" :name="ele.name" :key="ids">
          <div ref="newsContent" class="news_content" v-show="defaultTabTypeList.includes(tabsName)">
            <div class="tabs_conter" v-if="noticeList.length >0">
              <div class="tabs_conter_item" v-for="(item, index) in noticeList" :key="index" :class="item.hasRead === 0 ? 'unread_box' : ''">
                <!--未读标识-->
                <span class="unread_box_tips" v-if="item.hasRead === 0"></span>
                <!--通知标题-->
                <div class="title_box">
                  <div class="left_title">
                    <Checkbox v-model="item.selected" v-if="item.hasRead === 0"></Checkbox>
                    <div class="tabs_title" v-html="item.title" @click="jumpToQuery($event, item)"></div>
                  </div>
                  <span class="notice_time">{{ item.time }}</span>
                </div>
                <!--通知内容-->
                <div class="line_item">
                  <p class="text" v-html="item.content" @click="jumpToQuery($event, item)"></p>
                  <a class="details_txt ml5" v-if="item.informationType === 10" @click="toDetails(item)">{{ $t('key1000296') }} ></a>
                  <a class="details_txt ml5 text-decoration" v-if="item.informationType === 18" @click="toAuthorize(item)">{{ $t('key1000676') }}</a>
                </div>
              </div>
              <div class="noMoreData" v-if="!showMore">{{ $t('key1000677') }}</div>
            </div>
            <div v-else class="no_classify">
              <img :src="noContent" width="200" height="auto" alt="no content">
              <div class="txt">{{ $t('key1000104') }}</div>
            </div>
          </div>
          <!--系统公告-->
          <div ref="newsContent" class="news_content" v-show="tabsName === '6'">
            <div class="tabs_conter" v-if="systemAnnouncementList.length >0">
              <div class="tabs_conter_item" v-for="(item, index) in systemAnnouncementList" :key="index"
                :class="item.isRead === 0 ? 'unread_box' : ''">
                <span class="unread_box_tips" v-if="item.isRead === 0"></span>
                <div class="title_box">
                  <div class="left_title">
                    <Checkbox v-model="item.selected" v-if="item.isRead === 0" @on-change="systemChange"></Checkbox>
                    <div class="tabs_title" :title="item.title">{{ item.title }}</div>
                  </div>
                  <span class="notice_time">{{ item.time }}</span>
                </div>
                <div class="line_item">
                  <div style="color: #FD5425; cursor: pointer;"
                    @click="$refs['viewAnnouncement'].getViewAnnouncementData(item.noticeInfoId)">
                    {{ $t('key1002449') }}
                  </div>
                </div>
              </div>
              <div class="noMoreData" v-if="!showMore">{{ $t('key1000677') }}</div>
            </div>
            <div v-else class="no_classify">
              <img :src="noContent" width="200" height="auto" alt="no content">
              <div class="txt">{{ $t('key1000104') }}</div>
            </div>
          </div>
          <!--店铺上新-->
          <div ref="newsContent" class="news_content" v-show="tabsName === '5'">
            <div class="tabs_conter" v-if="shopNoticeData.length >0">
              <div class="storeNotice_box" v-for="(item, idx) in shopNoticeData" :key="idx">
                <span class="unread_box_tips" v-if="item.hasRead === 0"></span>
                <div class="storeNotice_box_title" @click="selectSupplier(item)">
                  <div class="img_box">
                    <img :src="setImgPath(item.shopLogoPath)" alt="">
                    <div class="title_item">
                      <h3 class="title" :title="item.name">{{ item.name }}</h3>
                      <span class="txt">{{ $t('key1005507') }}</span>
                    </div>
                  </div>
                  <p class="timer_box">{{ $t('key1005505') + item.createdTime }}</p>
                  <p class="timer_box">{{ $t('key1005506') + item.images.length }}</p>
                </div>
                <div class="storeNotice_box_content">
                  <Carousel :value="0" arrow="always" dots="none">
                    <CarouselItem v-for="(ele, index) in item.imgList" :key="index">
                      <div class="banner_img_item">
                        <div v-for="(talg ,idz) in ele" class="img-center-box">
                          <img class="img-center-style" v-lazy="getThumbnailImage(talg.path)" :key="idz"
                            @click="selectImg(item, talg)" alt="">
                        </div>
                      </div>
                    </CarouselItem>
                  </Carousel>
                </div>
              </div>
              <div class="noMoreData" v-if="!showMore">{{ $t('key1000677') }}</div>
            </div>
            <div v-else class="no_classify">
              <img :src="noContent" width="200" height="auto" alt="no content">
              <div class="txt">{{ $t('key1000104') }}</div>
            </div>
          </div>
        </TabPane>
      </Tabs>
      <div class="options_box" v-if="noticeList.length >0">
        <Checkbox v-model="seletctAll" @on-change="(val)=> changeSelectAll(val, 'order')">{{ $t('key1000790') }}</Checkbox>
        <div class="right_box">
          <div class="all_read" @click="allReadBtn">{{ $t('key1005508') }}</div>
          <div class="mark_read" @click="markReadBtn">{{ $t('key1005509') }}</div>
        </div>
      </div>
      <div class="options_box" v-if="systemAnnouncementList.length >0 && systemAllTalg">
        <Checkbox v-model="seletctAll" :indeterminate="indeterminate" @on-change="(val)=> changeSelectAll(val, 'system')">{{ $t('key1000790') }}</Checkbox>
        <div class="right_box">
          <div class="mark_read" @click="markReadBtn">{{ $t('key1005509') }}</div>
        </div>
      </div>
      <Checkbox class="readOnlyUnread_box" v-model="readOnlyUnread" @on-change="readOnlyUnreadChange">{{ $t('key1005510') }}</Checkbox>
    </div>
    <!--系统公告弹窗-->
    <viewAnnouncementModal :whetherInitial="false" ref="viewAnnouncement" @updateData="getSystemAnnouncementData()"></viewAnnouncementModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import viewAnnouncementModal from "@/components/common/viewAnnouncementModal.vue";
import {_handleMultilingualFields, commonLocalStorage, getMenuRoutingId, getSupplierData, pageJump} from "@/utils/common";
import {getAppScrollContainer} from "@/utils/appScroll";

export default {
  name: "newsList",
  mixins: [Mixin],
  data() {
    return {
      noContent: require('@/assets/images/noContent.gif'),
      tabsName: '0',
      seletctAll: false,
      indeterminate: false,
      showMore: true,
      noticeList: [],
      selectNoticeList: [],
      tabTalg: false,
      typeList: [
        {name: '0', informationTypeList: [], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {name: '1', informationTypeList: [1, 16], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005499')},
        {name: '2', informationTypeList: [8], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005500')},
        {name: '3', informationTypeList: [9], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001762')},
        {name: '4', informationTypeList: [10], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005501')},
        {name: '5', informationTypeList: [11], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005502')},
        {name: '6', informationTypeList: [12], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001126')},
        {name: '7', informationTypeList: [13, 14, 15], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005503')},
        {name: '8', informationTypeList: [18], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001792')},
        {name: '9', informationTypeList: [19], label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001797')}
      ],
      pageParam: {
        hasRead: null, // null 全部 0未读 1已读
        informationTypeList: [],
        nextToken: null,
        pageNum: 1,
        pageSize: 50
      },
      isScroll: true, //是否可以滚动
      distanceHeight: 300,
      shopNoticeData: [],
      shopNoticeParam: {
        hasRead: null,
        informationType: 11,
        pageNum: 1,
        pageSize: 50
      },
      systemParam: {
        isRead: null, // 是否已读 null全部 0否 1是
        pageNum: 1,
        pageSize: 50,
        subsystemName: 'distributor'
      },
      systemAnnouncementList: [],
      systemAllTalg: null,
      readOnlyUnread: true,
    };
  },
  mounted() {
    let v = this;
    getAppScrollContainer().addEventListener('scroll', v.handleReachBottom, true);
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    selectInformationType() {
      return this.$route.query.informationType;
    },
    // 默认的通知Tab类型
    defaultTabTypeList() {
      return this.typeList.map((item) => {
        if (!['5', '6'].includes(item.name)) {
          return item.name;
        }
      });
    }
  },
  methods: {
    // 批量获取供应商基本信息数据
    getSupplierInfo(data) {
      let ymsSupplierMerchantIds = [];
      if (data.list && data.list.length > 0) {
        data.list.map((item) => {
          ymsSupplierMerchantIds.push(item.supplierMerchantId);
        });
        if (ymsSupplierMerchantIds.length > 0) {
          return new Promise((resolve, reject) => {
            getSupplierData(ymsSupplierMerchantIds).then(list => {
              resolve(list);
            });
          });
        }
      }
    },
    // 查看详情
    toDetails(item) {
      this.$router.push({
        path: '/newsListDetails',
        query: {
          ymsReceiveStationNotificationLogId: item.ymsReceiveStationNotificationLogId
        }
      });
    },
    // 点击去授权
    toAuthorize(item) {
      let v = this;
      const content = item.content;
      if (content) {
        // 匹配第一个id,获取平台id值
        const match = content.match(/id="([^"]+)"/);
        const platformId = match ? match[1] : null;
        if (platformId) {
          let id = getMenuRoutingId('/platformStoreList');
          localStorage.setItem('distributorActiveName', id);
          let obj = {
            platformId: platformId,
            platformAccountStatus: 0
          };
          commonLocalStorage.setItem('platformStoreListQuery', obj);
          v.$store.commit('updateDistributorMenu', true);
          setTimeout(() => {
            v.$router.push({
              path: '/platformStoreList'
            });
          }, 200);
        }
      }
    },
    // 获取商品通知的数据
    getYmsProductNotice() {
      let v = this;
      v.isScroll = false;
      let value = JSON.stringify(v.pageParam.informationTypeList);
      if (value === '[]') {
        v.tabsName = '0';
      } else {
        v.typeList.map((item) => {
          let val = JSON.stringify(item.informationTypeList);
          if (val === value) {
            v.tabsName = item.name;
          }
        });
      }
      v.pageParam.hasRead = v.readOnlyUnread ? 0 : null;
      v.axios.post(api.post_ymsDistributorStationNotification_query, v.pageParam).then(response => {
        v.$store.commit('updateDistributorMenu', false);
        if (response.data.code === 0) {
          let data = response.data.datas;
          /**
           informationType: 通知消息类型
           1订单缺货、2备货超时、3拣货超时、4换单超时、5装箱超时、6发货超时、7订单取消
           8停售通知、9商品信息修改通知、10商品调价通知、16余额不足通知、12货品多发通知、
           13商品状态自动同步通知、14在线刊登自动调价通知、15 YMS订单自动取消通知、11商品上新通知
           */
          if (data) {
            let list = data.list || [];
            if (list.length > 0) {
              v.pageParam.nextToken = list[list.length - 1].ymsStationNotificationId;
              list.map((item) => {
                let attributeList = item.ymsStationNotificationExtends;
                if (attributeList && attributeList.length > 0) {
                  attributeList.map((talg) => {
                    item[talg.extendKey] = talg.value;
                  });
                }
                item.selected = false;
                item.time = v.$uDate.dealTime(item.createdTime, 'fulltime');
              });
              v.noticeList = [...v.noticeList, ...list];
              v.$nextTick(() => {
                v.$forceUpdate();
              });
              v.showMore = true;
              v.isScroll = true;
            } else {
              v.showMore = false;
              v.isScroll = false;
            }
          }
        }
      });
    },
    // 切换tab栏
    changeTab(name) {
      let v = this;
      v.systemAnnouncementList = [];
      v.shopNoticeData = [];
      v.noticeList = [];
      v.selectNoticeList = [];
      v.showMore = false;
      v.seletctAll = false;
      let index = 0;
      let informationTypeList = [];
      v.typeList.map((item, idx) => {
        if (item.name === name) {
          index = idx;
          informationTypeList = item.informationTypeList;
        }
      });
      v.$nextTick(() => {
        if (v.$refs.newsContent[index]) {
          v.$refs.newsContent[index].scrollTop = 0;
        }
      });
      switch (index) {
        // 获取店铺上新通知的数据
        case 5:
          v.shopNoticeParam.pageNum = 1;
          v.getShopNoticeData();
          break;
        // 获取系统公告
        case 6:
          v.systemParam.pageNum = 1;
          v.getSystemAnnouncementData();
          break;
        // 获取商品通知
        default:
          v.pageParam.nextToken = null;
          v.pageParam.pageNum = 1;
          v.pageParam.informationTypeList = informationTypeList;
          v.getYmsProductNotice();
          break;
      }
    },
    // 全选
    changeSelectAll(value, type) {
      let v = this;
      if (type === 'order') {
        v.noticeList.map((item) => {
          item.selected = !!value;
        });
      } else if (type === 'system') {
        v.systemAnnouncementList.map((item) => {
          item.selected = !!value;
        });
      }
    },
    // 标记已读后，更新、重置数据
    updateData() {
      this.noticeList = [];
      this.selectNoticeList = [];
      this.shopNoticeParam.pageNum = 1;
      this.pageParam.pageNum = 1;
      this.pageParam.nextToken = null;
      this.getYmsProductNotice();
      this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
    },
    // 标记已读
    markReadBtn() {
      let v = this;
      if (v.tabsName === '6') {
        let noticeInfoIds = [];
        if (v.systemAnnouncementList.length > 0) {
          v.systemAnnouncementList.map((item) => {
            if (item.selected && item.isRead === 0) {
              noticeInfoIds.push(item.noticeInfoId);
            }
          });
          if (noticeInfoIds.length > 0) {
            v.axios.post(api.post_ymsNoticeInfo_disable, noticeInfoIds, {
              loading: true,
              loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
            }).then(response => {
              if (response.data.code === 0) {
                v.systemAnnouncementList = [];
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
                setTimeout(() => {
                  v.systemParam.pageNum = 1;
                  v.getSystemAnnouncementData();
                }, 500);
              }
            });
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005504'));
            return false;
          }
        }
      } else {
        v.selectNoticeList = [];
        v.noticeList.map((item) => {
          if (item.selected) {
            v.selectNoticeList.push(item.ymsReceiveStationNotificationLogId);
          }
        });
        if (v.selectNoticeList.length > 0) {
          v.axios.put(api.put_ymsStationNotification_api_markRead, v.selectNoticeList).then((response) => {
            if (response.data.code === 0) {
              v.updateData();
              v.getMessageNotificationData(api.get_ymsDistributorStationNotification_lastUnRead);
            }
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005504'));
          return false;
        }
      }
    },
    // 全部标记已读
    allReadBtn() {
      let v = this;
      let messageTab = [];
      v.typeList.map((item) => {
        if (item.name === v.tabsName) {
          messageTab = item.informationTypeList;
        }
      });
      let query = {
        messageTab: messageTab,
        distributorMerchantId: v.userInfo.merchantId
      };
      v.axios.put(api.put_ymsDistributorStationNotification_markAllAndNewRead, query).then((response) => {
        if (response.data.code === 0) {
          v.updateData();
          v.getMessageNotificationData(api.get_ymsDistributorStationNotification_lastUnRead);
        }
      });
    },
    // 滚动加载更多数据
    handleReachBottom(e) {
      let v = this;
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = e.target.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight = e.target.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = e.target.scrollHeight;
      //滚动条到底部的条件
      v.$store.commit('scrollPosition', scrollTop);
      if ((scrollTop + windowHeight) + v.distanceHeight >= scrollHeight && v.isScroll) {
        if (v.showMore && v.$route.path === '/newsList') {
          switch (v.pageParam.informationType) {
            case 11:
              v.shopNoticeParam.pageNum += 1;
              this.getShopNoticeData();
              break;
            case 12:
              v.systemParam.pageNum += 1;
              v.getSystemAnnouncementData();
              break;
            default:
              v.pageParam.pageNum += 1;
              this.getYmsProductNotice();
              break;
          }
        }
      }
    },
    // 跳转到商城商品详情页
    toshopDetails(data) {
      let id = null;
      if (data.informationType === 11) {
        id = data.ymsProductId;
      } else {
        id = data.businessId;
      }
      pageJump(`/index.html#/shopDetails/${id}`, '/yms-shopping-service', '_blank');
    },
    // 获取店铺上新通知的数据
    getShopNoticeData() {
      let v = this;
      v.isScroll = false;
      let value = JSON.stringify([v.shopNoticeParam.informationType]);
      v.typeList.map((item) => {
        let val = JSON.stringify(item.informationTypeList);
        if (val === value) {
          v.tabsName = item.name;
        }
      });
      v.shopNoticeParam.hasRead = v.readOnlyUnread ? 0 : null;
      v.axios.post(api.post_ymsDistributorStationNotification_queryNew, v.shopNoticeParam).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let list = data.list || [];
            if (list.length > 0) {
              list.map((item) => {
                item.images = [];
                let attributeList = item.ymsStationNotificationExtends;
                if (attributeList && attributeList.length > 0) {
                  attributeList.map((talg) => {
                    if (talg.extendKey === 'extendContentJson') {
                      if (talg.value) {
                        let obj = JSON.parse(talg.value);
                        if (obj.path !== 'null') {
                          obj.path = obj.path.split(',');
                          if (obj.path.length > 0) {
                            obj.path.map((ele) => {
                              item.images.push({
                                informationType: item.informationType,
                                path: ele,
                                ymsProductId: obj.ymsProductId
                              });
                            });
                          }
                        }
                      }
                    } else {
                      item[talg.extendKey] = talg.value;
                    }
                  });
                }
                item.images = v.uniqueFunc(item.images, 'path');
                item.imgList = v.handlerImg(10, item.images);
                item.name = '';
                item.createdTime = v.$uDate.dealTime(item.createdTime, 'fulltime');
              });
              v.getSupplierInfo(data).then((newList) => {
                list.map((item) => {
                  newList.map((ele) => {
                    if (item.supplierMerchantId === ele.ymsMerchantId) {
                      item.name = _handleMultilingualFields(ele.name);
                      item.shopLogoPath = ele.shopLogoPath;
                      item.supplierSecondLevelDomain = ele.supplierSecondLevelDomain;
                    }
                  });
                });
                v.shopNoticeData = [...v.shopNoticeData, ...list];
                v.$nextTick(() => {
                  v.$forceUpdate();
                });
                v.showMore = true;
                v.isScroll = true;
              });
            } else {
              v.showMore = false;
              v.isScroll = false;
            }
          }
        }
      });
    },
    // 处理图片数据
    handlerImg(length, arr) {
      let new_arr = [];
      for (let i = 0; i < arr.length;) {
        new_arr.push(arr.slice(i, i += length));
      }
      return new_arr;
    },
    // 选中当前图片
    selectImg(data, ele) {
      let v = this;
      v.shopMarkRead(data).then((val) => {
        if (val) {
          setTimeout(() => {
            v.toshopDetails(ele);
          }, 800);
        }
      });
    },
    // 跳转到供应商店铺列表
    selectSupplier(data) {
      this.shopMarkRead(data).then((val) => {
        if (val) {
          setTimeout(() => {
            window.open(data.supplierSecondLevelDomain + '?orderBy=publishTime', '_blank');
          }, 800);
        }
      });
    },
    // 店铺上新标记已读后，重新刷新数据
    shopUpdateData() {
      this.shopNoticeData = [];
      this.shopNoticeParam = {
        hasRead: 0,
        type: 4,
        pageNum: 1,
        pageSize: 15
      };
      this.getShopNoticeData();
      this.getMessageNotificationData(api.get_ymsDistributorStationNotification_lastUnRead);
    },
    // 店铺上新标记已读
    shopMarkRead(data) {
      let v = this;
      return new Promise((resolve) => {
        if (data.hasRead === 0) {
          let query = {
            messageTab: v.shopNoticeParam.informationType,
            onTheNewTime: data.createdTime,
            supplierMerchantId: data.supplierMerchantId,
            distributorMerchantId: v.userInfo.merchantId
          };
          v.axios.put(api.put_ymsDistributorStationNotification_markAllAndNewRead, query).then((response) => {
            if (response.data.code === 0) {
              v.shopUpdateData();
              resolve(true);
            }
          });
        } else {
          resolve(true);
        }
      });
    },
    // 跳转到指定页面并查询对应的数据
    jumpToQuery(event, item) {
      let v = this;
      let informationType = item.informationType;
      switch (informationType) {
        // 订单缺货、YMS订单自动取消通知
        case 1:
        case 15:
          let ymsPackageId = event.target.id;
          if (ymsPackageId) {
            let id = getMenuRoutingId('/myOrder');
            localStorage.setItem('distributorActiveName', id);
            v.$store.commit('updateDistributorMenu', true);
            setTimeout(() => {
              v.$router.push({
                path: '/myOrderDetails',
                query: {
                  ymsPackageId: ymsPackageId
                }
              });
            }, 500);
          }
          break;
        // 停售通知、商品信息修改通知、商品调价通知、商品状态自动同步通知、在线刊登自动调价通知
        case 8:
        case 9:
        case 10:
        case 13:
        case 14:
          pageJump(`/index.html#/shopDetails/${item.businessId}`, '/yms-shopping-service', '_blank');
          break;
        // 余额不足通知
        case 16:
          let targetData = event.target.id;
          if (targetData) {
            let id = getMenuRoutingId('/platformOrder');
            localStorage.setItem('distributorActiveName', id);
            let val = targetData.split('-');
            let obj = {
              platformId: val[0],
              platformOrderNos: val[1]
            };
            localStorage.setItem('platformOrderQuery', JSON.stringify(obj));
            v.$store.commit('updateDistributorMenu', true);
            setTimeout(() => {
              v.$router.push({
                path: '/platformOrder'
              });
            }, 200);
          }
          break;
        // 店铺授权过期通知
        case 18:
          let platformId = event.target.id;
          if (platformId) {
            let id = getMenuRoutingId('/platformStoreList');
            localStorage.setItem('distributorActiveName', id);
            let obj = {
              platformId: platformId,
              platformAccountStatus: 0
            };
            commonLocalStorage.setItem('platformStoreListQuery', obj);
            v.$store.commit('updateDistributorMenu', true);
            setTimeout(() => {
              v.$router.push({
                path: '/platformStoreList'
              });
            }, 200);
          }
          break;
      }
    },
    // 获取系统公告数据
    getSystemAnnouncementData() {
      this.systemParam.merchantId = this.userInfo.merchantId;
      this.systemParam.isRead = this.readOnlyUnread ? 0 : null;
      this.axios.post(api.post_ymsNoticeInfo_queryNewNoticeInfo, this.systemParam).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          let list = data.list || [];
          if (list.length > 0) {
            this.systemAnnouncementList = [...this.systemAnnouncementList, ...list];
            if (this.systemAnnouncementList.length > 0) {
              this.systemAnnouncementList.map((item) => {
                item.selected = false;
                item.time = this.$uDate.dealTime(item.createdTime, 'fulltime');
              });
            }
            this.showMore = true;
            this.isScroll = true;
            this.$forceUpdate();
          } else {
            this.showMore = false;
            this.isScroll = false;
          }
        }
      });
    },
    // 勾选中系统公告
    systemChange(val) {
      if (this.tabsName === '6' && this.systemAnnouncementList.length > 0) {
        this.indeterminate = false;
        this.seletctAll = false;
        let list = this.systemAnnouncementList.filter((ele) => {
          return ele.isRead === 0;
        });
        if (list.length > 0) {
          let whereinTalg = list.some((item) => {
            return item.selected === true;
          });
          let selectAllTalg = list.every((item) => {
            return item.selected === true;
          });
          if (whereinTalg) {
            this.indeterminate = true;
          }
          if (selectAllTalg) {
            this.indeterminate = false;
            this.seletctAll = true;
          }
        }
      }
    },
    // 仅看未读
    readOnlyUnreadChange() {
      this.changeTab(this.tabsName);
    }
  },
  deactivated() {
    getAppScrollContainer().removeEventListener('scroll', this.handleReachBottom, true);
    window.onscroll = null;
  },

  beforeRouteEnter(to, from, next) {
    next(v => {
      let index = Number(v.tabsName);
      v.$nextTick(() => {
        v.isScroll = true;
        if (v.$refs.newsContent[index]) {
          v.$refs.newsContent[index].scrollTop = v.$store.state.scrollPosition;
        }
      });
    });
  },
  watch: {
    selectInformationType: {
      handler(value) {
        if (value !== 'null') {
          let val = Number(value);
          this.typeList.map((item) => {
            if (item.informationTypeList.includes(val)) {
              this.changeTab(item.name);
            }
          });
        } else {
          this.changeTab('0');
        }
      },
      immediate: true,
      deep: true
    },
    systemAnnouncementList: {
      handler(data) {
        this.systemAllTalg = null;
        this.indeterminate = false;
        if (this.tabsName === '6' && data.length > 0) {
          let talg = data.some((item) => {
            return item.isRead === 0;
          });
          this.systemAllTalg = talg;
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    viewAnnouncementModal
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.newsList_box {
  width: 100%;
  height: 549px;
  position: relative;

  /deep/ .ivu-tabs-bar {
    margin-bottom: 0 !important;
    width: 85%;
  }

  .news_content {
    height: 440px;
    overflow-y: auto;

    .tabs_conter {

      .tabs_conter_item {
        padding: 20px 17px;
        border-bottom: 1px solid #dcdee2;

        .title_box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .left_title {
            display: flex;
            align-items: center;

            .tabs_title {
              font-size: 15px;
              color: #666;
              max-width: 730px;
              .ellipsis(1);
            }
          }

          .notice_time {
            color: #666;
            font-size: 13px;
          }
        }

        .line_item {
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;

          .text {
            color: #666;
            font-size: 13px;

            .txt {
              display: inline-block;
              color: @subject_color;
            }

            .details_txt {
              font-size: 13px;
              display: inline-block;
              margin-left: 10px;
              color: @subject_color;
            }
          }

          /deep/ .blueColor {
            cursor: pointer;
            color: #FD5425 !important;
            margin-right: 6px;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .unread_box {
        position: relative;

        .unread_box_tips {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 27px;
          background-color: @subject_color;
        }

        .tabs_title {
          color: #000 !important;
          font-weight: bold;
        }
      }

      .noMoreData {
        color: #666;
        font-size: 14px;
        padding: 10px 0;
        text-align: center;
        width: 100%;
      }

      .storeNotice_box {
        padding: 15px 0;
        display: flex;
        width: 100%;
        margin: 0 auto;
        border-bottom: 1px solid #dcdee2;
        box-sizing: border-box;
        position: relative;

        .unread_box_tips {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          position: absolute;
          left: -14px;
          top: 15px;
          background-color: @subject_color;
        }

        .storeNotice_box_title {
          width: 350px;
          box-sizing: border-box;
          cursor: pointer;

          .img_box {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            img {
              width: 55px;
              height: 55px;
              display: inline-block;
              margin-right: 15px;
            }

            .title_item {
              .title {
                color: #333;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 6px;
                max-width: 280px;
                .ellipsis(1)
              }

              .txt {
                border: 1px solid #FD5425;
                border-radius: 5px;
                padding: 2px 7px;
                color: #FD5425;
                font-size: 13px;
              }
            }
          }

          .timer_box {
            margin: 5px 0;
            color: #666;
            font-size: 13px;
          }
        }

        .storeNotice_box_content {
          box-sizing: border-box;
          flex: 1;
          overflow: hidden;

          /deep/ .ivu-carousel {
            width: 100%;
            height: 126px;

            .banner_img_item {
              width: 100%;
              display: flex;
              /*justify-content: space-around;*/

              .img-center-box {
                width: 120px;
                height: 120px;
                cursor: pointer;
                position: relative;
              }
            }
          }
        }
      }
    }
  }

  .options_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0;
    z-index: 1000;
    background-color: #fff;

    .right_box {
      display: flex;
      align-items: center;

      .all_read, .mark_read {
        height: 38px;
        line-height: 38px;
        border-radius: 2px;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
      }

      .all_read {
        width: 130px;
        border: 1px solid @subject_color;
        color: @subject_color;
        box-sizing: border-box;

        &:hover {
          color: #fff;
          background-color: @subject_color;
        }
      }

      .mark_read {
        width: 110px;
        color: #fff;
        background-color: @subject_color;
        margin-left: 5px;
      }
    }
  }

  .no_classify {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 400px;

    .txt {
      font-size: 15px;
      color: #666;
      margin-top: 15px;
    }
  }

  .readOnlyUnread_box {
    position: absolute;
    top: 8px;
    right: 0;

    &:after {
      position: absolute;
      bottom: -8px;
      right: 0;
      content: '';
      display: block;
      border-bottom: 1px solid #dcdee2;
      width: 400%;
    }
  }
}
</style>
